export default {
  FETCH_ANALYTICS_REQUEST: "FETCH_ANALYTICS_REQUEST",
  FETCH_ANALYTICS_FAILED: "FETCH_ANALYTICS_FAILED",
  FETCH_ANALYTICS_SUCCESS: "FETCH_ANALYTICS_SUCCESS",


  FETCH_DASHBOARDVIDEO_REQUEST: "FETCH_DASHBOARDVIDEO_REQUEST",
  FETCH_DASHBOARDVIDEO_SUCCESS: "FETCH_DASHBOARDVIDEO_SUCCESS",
  FETCH_DASHBOARDVIDEO_FAILED: "FETCH_DASHBOARDVIDEO_FAILED",

   
  FETCH_PENDINGDVIDEO_REQUEST: "FETCH_PENDINGDVIDEO_REQUEST",
  FETCH_PENDINGDVIDEO_SUCCESS: "FETCH_PENDINGDVIDEO_SUCCESS",
  FETCH_PENDINGDVIDEO_FAILED: "FETCH_PENDINGDVIDEO_FAILED",

   
  FETCH_VIDEOLIBRARY_REQUEST: "FETCH_VIDEOLIBRARY_REQUEST",
  FETCH_VIDEOLIBRARY_SUCCESS: "FETCH_VIDEOLIBRARY_SUCCESS",
  FETCH_VIDEOLIBRARY__FAILED: "FETCH_VIDEOLIBRARY__FAILED",


  APPROVAL_VIDEO_REQUEST: "APPROVAL_VIDEO_REQUEST",
  APPROVAL_VIDEO_SUCCESS: "APPROVAL_VIDEO_SUCCESS",
  APPROVAL_VIDEO_FAILED: "APPROVAL_VIDEO_FAILED",

  FETCH_WEEKLY_REQUEST: "FETCH_WEEKLY_REQUEST",
  FETCH_WEEKLY_SUCCESS: "FETCH_WEEKLY_SUCCESS",
  FETCH_WEEKLY__FAILED: "FETCH_WEEKLY__FAILED",

  DELETE_VIDEO_REQUEST:'DELETE_VIDEO_REQUEST',
  DELETE_VIDEO_SUCCESS:'DELETE_VIDEO_SUCCESS',
  DELETE_VIDEO_FAILED:'DELETE_VIDEO_FAILED',

  SendLibraryVideo_Request:'SendLibraryVideo_Request',
  SendLibraryVideo_Sucess:'SendLibraryVideo_Sucess',
  SendLibraryVideo__FAILED:'SendLibraryVideo__FAILED',
};
